/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
  currentDriver: {}
}

export const getters = {}

export const mutations = {
  SET_DRIVERS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_DRIVER(state, objects) {
    state.currentDriver = objects
  }
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getDrivers({ commit }) {
    try {
      const response = await
          graphqlClient.query({
              query: gql`
              query getDrivers{
                drivers {
                  id
                  username
                  name
                  email
                  mobile
                  drivers_licence_no
                  drivers_licence_expiry
                  emergency_contact_no
                  emergency_contact_name
                  created_at
                  deleted_at
                  updated_at
                }
              }
            `,
          })
        commit('SET_DRIVERS', response.data.drivers)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async driverById({ commit }, { id } = {}) {
    try {
      await graphqlClient.query({
        query: gql`
          query GetDriverById($did: ID!){
            driverById(id: $did) {
              id
              username
              name
              mobile
              email
              photos{
                id
                url
              }
              drivers_licence_no
              drivers_licence_expiry
              emergency_contact_no
              emergency_contact_name
              created_at
              deleted_at
              updated_at
            }
          }
        `,
        variables:{ did: id }
      }).then((response) => {
        if(response && response.data && response.data.driverById){
          commit('SET_DRIVER', response.data.driverById)
          return response.data.driverById
        }
      })

    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createDriver({ commit, dispatch }, {name, username, mobile, email, password, driversLicenceNo, driversLicenceExpiry, emergencyContactName, emergencyContactNumber} = {}) {
    try {
      await graphqlClient.mutate({
        mutation: gql`
        mutation CreateDriver($uname: String! $pwrd: String! $nme: String! $mble: String! $eml: String! $driversLicenceNo: String! $driversLicenceExpiry: String! $emergencyContactName: String! $emergencyContactNumber: String!)  {
          createDriver(driver:{username:$uname password:$pwrd name:$nme mobile:$mble email:$eml drivers_licence_no:$driversLicenceNo drivers_licence_expiry:$driversLicenceExpiry emergency_contact_name: $emergencyContactName emergency_contact_no: $emergencyContactNumber} ) {
            id
            username
          }
        }
        `,
        variables: { uname: username, pwrd: password, nme: name, mble: mobile, eml: email,driversLicenceNo:driversLicenceNo, driversLicenceExpiry:driversLicenceExpiry, emergencyContactName: emergencyContactName, emergencyContactNumber: emergencyContactNumber},
      })
      dispatch('getDrivers')
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createDriverPhoto({ commit, dispatch }, {driverId, url} = {}) {
    try {
      await graphqlClient.mutate({
        mutation: gql`
        mutation addDriverPhoto( $driverId: String! $url: String!)  {
          addDriverPhoto(photo:{driver_id:$driverId url: $url} ) {
            id
          }
        }
        `,
        variables: { driverId: driverId, url: url },
      }).then((response) => {
        // console.log(response)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async deleteDriverPhoto({ commit, dispatch }, {Id} = {}) {
    try {
      // console.log(Id);
      await graphqlClient.mutate({
        mutation: gql`
        mutation removeDriverPhoto($Id: Int!)  {
          removeDriverPhoto(id:$Id) {
            id
          }
        }
        `,
        variables: { Id: Id },
      }).then((response) => {
        // console.log(response)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateDriver({ commit }, {id, name, username, mobile, email, password,drivers_licence_no, drivers_licence_expiry, emergency_contact_name, emergency_contact_no} = {}) {
    try {

      await graphqlClient.mutate({
        mutation: gql`
        mutation UpdateDriver($did:Int! $uname: String $pwrd: String $nme: String $mble: String $eml: String $drivers_licence_no: String! $drivers_licence_expiry: String! $emergency_contact_name: String! $emergency_contact_no: String!)  {
          updateDriver(id: $did driver:{username:$uname password:$pwrd name:$nme mobile:$mble email:$eml, drivers_licence_no:$drivers_licence_no, drivers_licence_expiry:$drivers_licence_expiry emergency_contact_name: $emergency_contact_name emergency_contact_no: $emergency_contact_no}) {
            id
          }
        }
        `,
        variables: { did: id, uname: username, pwrd: password, nme: name, mble: mobile, eml: email,drivers_licence_no:drivers_licence_no, drivers_licence_expiry:drivers_licence_expiry, emergency_contact_name: emergency_contact_name, emergency_contact_no: emergency_contact_no },
      }).then((response) =>{
        // console.log(response)
        commit('SET_DRIVERS', response.data.updateDriver)
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async deleteDriver({ commit }, {id} = {}) {
      try {
          const response = await graphqlClient.mutate({
              mutation: gql`
              mutation DeleteDriver($did:Int!)  {
                deleteDriver(id: $did) {
                  id
                }
              }
              `,
              variables: { did: id},
          })
          commit('SET_DRIVERS', response.data.deleteDriver)
      } catch (ex) {
          console.error(ex)
          throw ex
      }
  }
}
